export default {"src":"/_next/static/media/financial-report-hero-bg.eb7b79a9.svg","height":405,"width":439,"blurWidth":0,"blurHeight":0};